
import Vue from "vue";
import { Component } from "vue-property-decorator";
import ProOnlyAlertBox from "@/components/Subscription/ProOnlyAlertBox.vue";
@Component({
  components: { ProOnlyAlertBox }
})
export default class FreeModeAlertForSelectors extends Vue {}
